import { IComponent } from "@/admin/helpers/interfaces/component-types";
import uuid from "react-uuid";

import $ from "jquery";

export const scrollToTop = (): void => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const handleClickScroll = (id: string): void => {
  const element = document.getElementById(id);
  if (element) {
    // 👇 Will scroll smoothly to the top of the next section
    (element as HTMLElement).scrollIntoView({ behavior: "smooth" });
  }
};

export function doAnimations(elements: JQuery<HTMLElement>): void {
  var animationEndEvents =
    "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
  elements.each(function () {
    var $this = $(this);
    var $animationDelay = $this.data("delay");
    var $animationType = "animated " + $this.data("animation");
    $this.css({
      "animation-delay": $animationDelay,
      "-webkit-animation-delay": $animationDelay,
    });
    $this.addClass($animationType).one(animationEndEvents, function () {
      $this.removeClass($animationType);
    });
  });
}

export function groupArray(array: any, rows: number): any {
  let talents = [...Array(array.length / rows)];
  console.log(talents);
  const oldRow = rows;
  const talentsRow = talents.map((row, idx) => {
    return array.slice(idx * rows, idx * rows + rows);
  });
  return talentsRow;
}

export function findNestedItem(
  obj: IComponent,
  id: string,
  component: IComponent
): any {
  if (obj.id === id) {
    //first element in  page
    obj.childrens?.push(component);
    return;
  } else {
    obj.childrens?.map((item: IComponent) => {
      return findNestedItem(item, id, component);
    });
  }
}

export function addProps(obj: IComponent, id: string, props: any): any {
  if (obj.id === id) {
    let newProps = { ...obj.props, ...props };
    obj.props = JSON.parse(JSON.stringify(newProps));
    return;
  } else {
    obj.childrens?.map((item: IComponent) => {
      return addProps(item, id, props);
    });
  }
}

export function deleteNestedItem(arr: IComponent[], id: string) {
  arr.map((item, index) => {
    if (item.id === id) {
      return arr.splice(index, 1);
    } else if (item.childrens) {
      return deleteNestedItem(item.childrens, id);
    }
  });
}

export function refactorProps(obj: any, languages?: any, props?: any) {
  if (obj) {
    const initialObject = JSON.parse(JSON.stringify(obj));
    const formatedObj = {};
    let translation: any = {};

    Object.keys(initialObject).map((item, index) => {
      if (
        (props[item]?.type != "object" &&
          languages &&
          props[item]?.isTranslated === true) ||
        props[item]?.isTranslated === "true"
      ) {
        languages.map((lang: any, index: number) => {
          let key = obj[item];
          let keyTranslation = obj[item + "_" + lang.iSOCode];

          translation = {
            ...translation,
            [lang.iSOCode]: {
              ...translation[lang.iSOCode],
              [key]: keyTranslation,
            },
          };
        });
      } else if (props[item]?.type === "object") {
        obj[item]?.value.map((el: any) => {
          const obj = Object.keys(el);
          obj.map((key: any) => {
            if (
              el[key].isTranslated === true ||
              el[key].isTranslated === "true"
            ) {
              let keyT = el[key].value;
              el[key].translation.map((item: any, index: number) => {
                translation = {
                  ...translation,
                  [item.ISOCode]: {
                    ...translation[item.ISOCode],
                    [keyT]: item.value,
                  },
                };
              });
            }
          });
        });
      }
      if (props[item]) {
        if (props[item].type === "object") {
          props[item].value = obj[item].value;
        } else {
          props[item].value = obj[item];
        }
      } else {
        Object.assign(props, { [item]: { value: obj[item], isHiden: true } });
      }
    });

    return { translation: translation, object: props };
  }
  return {};
}

export function getLanguagesObject(languages: any, value?: string) {
  let lang: any = [];

  languages.map((item: any, index: number) => {
    lang = [...lang, { value: value, flag: item.flag, ISOCode: item.iSOCode }];
  });

  return lang;
}

function objectInitializer(obj: any, languages: any) {
  Object.keys(obj).map((key: string, index: number) => {
    if (obj[key].type === "object") {
      obj[key].value?.map((item: any, index: number) => {
        Object.keys(item).map((el: any, index: number) => {
          if (
            !item[el].translation &&
            (item[el].isTranslated === true || item[el].isTranslated === "true")
          ) {
            let oldValue = JSON.parse(JSON.stringify(item[el].value));

            item[el].value = uuid().toString();
            item[el].translation = getLanguagesObject(languages, oldValue);
          }
        });
      });
    }
  });

  return obj;
}

export function formatObject(obj: any, languages?: any) {
  if (obj) {
    let newObj = languages ? objectInitializer(obj, languages) : obj;

    const initialObject = JSON.parse(JSON.stringify(newObj));
    const formatedObj = {};
    let languageList = {};
    Object.keys(initialObject).map((item, index) => {
      if (
        languages &&
        (obj[item]?.isTranslated === true || obj[item]?.isTranslated === "true")
      ) {
        languages.map((lang: any, index: number) => {
          languageList = {
            ...languageList,
            [item + "_" + lang.iSOCode]:
              obj[item + "_" + lang.iSOCode] || obj[item].value,
          };
        });

        return Object.assign(formatedObj, {
          [item]: obj[item]?.value,
          ...languageList,
        });
      } else if (obj[item]?.type !== "object") {
        return Object.assign(formatedObj, { [item]: obj[item]?.value });
      } else {
        return Object.assign(formatedObj, { [item]: obj[item] });
      }
    });

    return formatedObj;
  }
  return {};
}

export function stringToKey(str: any): string {
  if (typeof str !== "string") {
    return "";
  }

  return str
    .replace(/\s(.)/g, function ($1) {
      return $1.toUpperCase();
    })
    .replace(/\s/g, "")
    .replace(/^(.)/, function ($1) {
      return $1.toLowerCase();
    });
}

export function camelToFlat(str: string) {
  const camelCase = str.replace(/([a-z])([A-Z])/g, "$1 $2");

  return camelCase;
}

export function uuidValidator(str: string) {
  const uuidPattern =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

  return str.match(uuidPattern);
}

// mode , type, item, item_lang == null

// mode, {type, prodTranslation, devTranslation}

export function translationFactory(
  mode: string,
  parameters: {
    type: "object" | "item";
    prodTranslation?: any;
    devTranslation?: string;
    item?: any;
  }
): string {
  if (parameters.type === "item") {
    return mode === "DEV"
      ? parameters.devTranslation
        ? parameters.devTranslation
        : parameters.prodTranslation
      : parameters.prodTranslation;
  }

  return mode === "DEV"
    ? parameters.item?.translation && parameters.item?.translation.length > 0
      ? parameters.item.translation[0].value
      : parameters.prodTranslation
    : parameters.prodTranslation;
}
